<template>
  <div>
    <SimpleTextPopup
      :title="$t('parseUrlPopup')"
      v-model="value"
      :showTextbox="true"
      :rightButtonText="$t('continue')"
      @popupClose="$emit('input', false)"
      :rightMethod="toSignupContinueView"
      small/>
  </div>
</template>

<script>
import SimpleTextPopup from '@/components/SimpleTextPopup'
import { checkRules } from '@/utils/tools'
export default {
  name: 'ParseSignupUrlPopup',
  components: {
    SimpleTextPopup
  },
  mixins: [checkRules],
  methods: {
    getUrlParameters (url) {
      const params = {}
      const urlParts = url.split('?')
      if (urlParts.length > 2) {
        const queryString = [urlParts[1], decodeURIComponent(urlParts[2])].join('&')
        const paramPairs = queryString.split('&')
        paramPairs.forEach(pair => {
          const [key, value] = pair.split('=')
          const decodedKey = decodeURIComponent(key)
          const decodedValue = decodeURIComponent(value)
          params[decodedKey] = decodedValue
        })
      }
      return params
    },
    toSignupContinueView (text) {
      const url = text
      const emailRegex = /email%3D([^&]+)/
      const match = url.match(emailRegex)
      const extractedEmail = match ? decodeURIComponent(match[1]) : null
      const isValid = this.fieldIsEmail()(extractedEmail) === true && this.email === extractedEmail

      if (isValid) {
        const params = this.getUrlParameters(url)
        delete params.continueUrl
        if (params.mode === 'resetPassword') {
          return this.$router.push({ path: '/confirmResetPassword', 
            query: {
              email: this.email,
              apiKey: params.apiKey,
              oobCode: params.oobCode
            }})
        } 
        this.$router.push({ path: '/signupContinue', query: params })
      } else {
        this.$store.dispatch('showToast', {info: 'Invalid referral link.'})
      }
    }
  },
  props: {
    email: String,
    value: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ParseSignupUrlPopup.vue